export const checkLatitude = (value: number) => {
    return -180 <= value && value <= 180;
};

export const checkLongitude = (value: number) => {
    return -90 <= value && value <= 90;
};
